export default {
    "de": "German",
    "en": "English"
}